import './tel';
import './truncate';
import './unique';
import './capitalize';
import './uriencode';
import './petage';
import './todictionaryarray';
import './dateparse';
import './url';
import './objectkeylength';
